import React from 'react'
import { SvgIconProps } from './Home'

const SvgCheckInsIcon = ({ fill }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="16"
    fill="none"
    viewBox="0 0 18 16"
  >
    <path
      fill={fill ?? "#353535"}
      d="M16.924 1.569h-2.152V.94c0-.523-.49-.941-.979-.941-.586 0-.978.418-.978.941v.628h-7.63V.94c0-.523-.49-.941-.978-.941-.49 0-.979.418-.979.941v.628H.978c-.587 0-.978.418-.978.94v12.55c0 .523.49.941.978.941h9v-1.987H1.957v-7.32h13.989V8.26h1.956V2.51c.098-.523-.391-.941-.978-.941zm-.978 1.987v1.15H1.956v-1.15h13.99z"
    ></path>
    <path
      fill={fill ?? "#353535"}
      d="M17.413 9.516c-.391-.209-.978 0-1.174.314l-2.446 3.66-.88-1.255-.098-.104c-.293-.314-.88-.419-1.271-.105-.196.105-.294.418-.294.628 0 .209 0 .418.196.627l1.565 2.3c.196.21.489.419.783.419.293 0 .586-.105.782-.418l3.228-4.706.098-.105c.098-.209.098-.418.098-.627-.196-.314-.391-.419-.587-.628z"
    ></path>
  </svg>
)

export default SvgCheckInsIcon